<div class="annotation-list">
    <span
        hamIconShapes
        icon="assets/hamIcons/plus-outline.svg"
        [variant]="'gray'"
        [size]="'m'"
        [type]="'circle'"
        (click)="showNewAnnotationInput()"
        *ngIf="!newAnnotationFocused"
        [disabled]="disabled"
        style="margin-top: 4px"
    ></span>
    <!-- New Annotation -->
    <div class="new-annotation" *ngIf="newAnnotationFocused">
        <div class="textarea-wrapper">
            <textarea
                #newAnnotationTextarea
                [(ngModel)]="newAnnotationText"
                maxlength="500"
                rows="2"
                placeholder="Add annotation..."
                (keydown)="onKeyDown($event, 'new')"
                (keydown.enter)="onEnterKeyAdd($event)"
                (keydown.escape)="cancelAdd()"
                (keyup)="onMentionKey($event, 'new')"
                (blur)="endAdd($event)"
            ></textarea>
        </div>
    </div>
    <div *ngFor="let annotation of visibleAnnotations" class="annotation-entry">
        <!-- Edit Mode -->
        <div class="textarea-wrapper" *ngIf="editingId === annotation.id">
            <textarea
                #editTextarea
                [(ngModel)]="editBuffer[annotation.id]"
                maxlength="500"
                rows="2"
                (keydown)="onKeyDown($event, 'edit', annotation.id)"
                (keydown.enter)="onEnterKeyEdit($event, annotation)"
                (keydown.escape)="cancelEdit()"
                (keyup)="onMentionKey($event, 'edit', annotation.id)"
                (blur)="endEdit($event, annotation)"
            >
            </textarea>
        </div>

        <!-- Display Mode -->
        <div
            *ngIf="editingId !== annotation.id"
            class="annotation-view"
            [class.disabled]="disabled"
            (dblclick)="startEditing(annotation)"
        >
            <ham-avatar type="circle" size="s" [fullName]="getUserName(annotation.createdBy)"></ham-avatar>
            <div class="annotation-preview-text">
                <span
                    #annotationText
                    appLineCheck
                    class="annotation-preview-text"
                    [hamTooltip]="showTooltip[annotation.id] ? annotation.content : null"
                    [multiline]="true"
                    [innerHTML]="formatContentForView(annotation.content)"
                ></span>
                <span class="date-annotation">
                    {{ annotation.createdAt | dateTimeLocale : null : null : true : false }}
                </span>
            </div>

            <span
                class="icon"
                hamIconShapes
                icon="assets/hamIcons/trash-outline.svg"
                [variant]="'transparent'"
                [size]="'regular'"
                [type]="'circle'"
                (click)="remove(annotation)"
                [disabled]="disabled"
            ></span>
        </div>
    </div>

    <!-- View All -->
    <span class="showAllText" *ngIf="annotations.length > 3 && !showAll" (click)="showAll = true">{{
        'aumico_ui_view_all' | i18next
    }}</span>
    <!-- View Less -->
    <span class="showAllText" *ngIf="annotations.length > 3 && showAll" (click)="showAll = false">{{
        'aumico_ui_view_less' | i18next
    }}</span>
</div>

<!-- Autofocus script -->
<ng-container *ngIf="newAnnotationFocused">
    <ng-container *ngIf="newAnnotationFocused">
        <ng-template #autoFocusScript>
            <script>
                setTimeout(function () {
                    var el = document.querySelector('[#newAnnotationTextarea]');
                    if (el) el.focus();
                }, 0);
            </script>
        </ng-template>
    </ng-container>
</ng-container>

<ham-confirm-decline-modal
    *ngIf="showDeleteModal"
    (cancel)="cancelDelete()"
    (action)="confirmDelete()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_button_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_button_cancel' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="
            'aumico_app_cpmm_annotation_delete_confirmation'
                | i18next : { comment: getTruncatedContent(annotationToDelete?.content) }
        "
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>

<span
    class="menu-flyout"
    hamFlyout
    *ngIf="mentionFlyoutOpen"
    [position]="mentionFlyoutPosition"
    [style.transform]="mentionFlyoutPosition.isAbove ? 'translateY(-100%)' : null"
    (closeFlyout)="closeMentionFlyout()"
    (mousedown)="onFlyoutMouseDown($event)"
>
    <ul class="mention-flyout">
        <li 
            class="mention-option" 
            *ngFor="let user of mentionSuggestions; let i = index" 
            [class.selected]="i === mentionSelectedIndex"
            (click)="selectMention(user)"
            (mouseenter)="mentionSelectedIndex = i"
        >
            @{{ user.name }}
        </li>
    </ul>
</span>
